/**
 * Custom error classes for better error handling and debugging
 */

/**
 * Error thrown when an image fails to load
 */
export class ImageLoadError extends Error {
    constructor(message, context = {}) {
        super(message);
        this.name = 'ImageLoadError';
        this.context = context;
    }
}

/**
 * Error thrown when hotspot placement fails
 */
export class HotspotPlacementError extends Error {
    constructor(message, context = {}) {
        super(message);
        this.name = 'HotspotPlacementError';
        this.context = context;
    }
}

/**
 * Error thrown when navigation between images fails
 */
export class NavigationError extends Error {
    constructor(message, context = {}) {
        super(message);
        this.name = 'NavigationError';
        this.context = context;
    }
}

/**
 * Error thrown when URL validation fails
 */
export class ValidationError extends Error {
    constructor(message) {
        super(message);
        this.name = 'ValidationError';
    }
}

/**
 * Error thrown when API data loading fails
 */
export class ApiLoadError extends Error {
    constructor(message, context = {}) {
        super(message);
        this.name = 'ApiLoadError';
        this.context = context;
    }
}
